export default __webpack_public_path__ + "static/media/plus.984cab8f.svg";